import { render, staticRenderFns } from "./RichMenuLink.vue?vue&type=template&id=12860114&"
import script from "./RichMenuLink.vue?vue&type=script&lang=js&"
export * from "./RichMenuLink.vue?vue&type=script&lang=js&"
import style0 from "./RichMenuLink.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RichMenuLink.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports